import * as React from "react";


const columns = (t) => [

    {
        label: t ? t("common.part_name") : "Nazwa części",
        field: "name",
        sort: "desc",
        type: "tooltipImage",
        resolveImage: function (row) {
            return row.files[0];
        },
        width: 200,
    },
    // {
    //     label: "Uwagi",
    //     field: "comment",
    //     sort: "desc",
    //     width: 53,
    // },
    // {
    //     label: "Numer instalacyjny",
    //     field: "installationNumber",
    //     sort: "desc",
    //     width: 53,
    // },
    // {
    //     label: "Kontakt z produktem",
    //     field: "contactWithProduct",
    //     sort: "desc",
    //     width: 53,
    // },


];

export default columns;